import Mercure from "./mercure";

export default function addMercureInboxListener() {
    const mercure = new Mercure();
    mercure.addListener('inbox_new_message', (e: MessageEvent) => {
        document.dispatchEvent(new CustomEvent('inbox_new_message', {detail: JSON.parse(e.data)}));
    });
}
